(function () {
  var el = document.getElementById('wa-float');
  if (!el) return;

  var DELAY_ENTER = 500;
  var DELAY_DOTS  = 1800;
  var DELAY_ICON  = 600;

  setTimeout(function () {
    el.classList.remove('wa-float--phase-enter');
    el.classList.add('wa-float--phase-dots');
  }, DELAY_ENTER);

  setTimeout(function () {
    el.classList.remove('wa-float--phase-dots');
    el.classList.add('wa-float--phase-icon');
  }, DELAY_ENTER + DELAY_DOTS);

  setTimeout(function () {
    el.classList.remove('wa-float--phase-icon');
    el.classList.add('wa-float--phase-ready');
  }, DELAY_ENTER + DELAY_DOTS + DELAY_ICON);
})();
